import React from 'react'
import DropdownManagementFeature from '../../features/DropdownManagement/DropdownManagement'

const DropdownManagement = () => {
    return (
        <DropdownManagementFeature />
    )
}

export default DropdownManagement